import { render, staticRenderFns } from "./serviceProvider.vue?vue&type=template&id=15fbc1e8&scoped=true"
import script from "./serviceProvider.vue?vue&type=script&lang=js"
export * from "./serviceProvider.vue?vue&type=script&lang=js"
import style0 from "./serviceProvider.vue?vue&type=style&index=0&id=15fbc1e8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbc1e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15fbc1e8')) {
      api.createRecord('15fbc1e8', component.options)
    } else {
      api.reload('15fbc1e8', component.options)
    }
    module.hot.accept("./serviceProvider.vue?vue&type=template&id=15fbc1e8&scoped=true", function () {
      api.rerender('15fbc1e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channelManage/serviceProvider/serviceProvider.vue"
export default component.exports